import { CpReceiptsResponseInterface } from '../../../interfaces/response/receipts/cp-receipts-response-interface';
import { PaginationModel } from '@fh-client-interaction-frontends/fh-providers';
import { CpReceiptModel } from '../../dto/receipt/cp-receipt-model';

export class CpReceiptsResponseModel implements CpReceiptsResponseInterface {
  PaginationResult: PaginationModel = new PaginationModel();
  Receipts: CpReceiptModel[] = new Array<CpReceiptModel>();

  constructor(init?: Partial<CpReceiptsResponseModel>) {
    Object.assign(this, init);
  }
}
